import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { IRoleList } from "../utils/roles.types";


/**
 * Reset Password Thunk.
 */
export const fetchRoles = createAsyncThunk(
    'roles',
    async (): Promise<IRoleList> => {
        const response = await  axios.get('/api/v1/role');
        return response.data.rolesList;
    }
);
